import { h } from 'preact'
import Router from 'preact-router'
import AsyncRoute from 'preact-async-route'
import Loading from '../components/Loading/Loading'
import useLocale from '../hooks/useLocale'
import useCurrentRoute from '../hooks/useCurrentRoute'
import { getRoutesByLocale } from './Pages'

// TODO: generate routes from route array?
const HOME = () => import('../screens/Home').then((module) => module.default)
const ABOUT = () => import('../screens/About').then((module) => module.default)
const CONSTELLATION = () => import('../screens/Constellation').then((module) => module.default)
const ARTISTS = () => import('../screens/Artists').then((module) => module.default)
const CHAPTERS = () => import('../screens/Chapters').then((module) => module.default)

const Routes = () => {
    const locale = useLocale()
    const routes = getRoutesByLocale(locale)
    const currentPath = useCurrentRoute()

    const handleRoute = (e: { url: string; previous?: string }) => {
        // Scroll to top synchronously (this is fine)
        if (typeof window.scrollTo === 'function') {
            window.scrollTo({ top: 0, left: 0 })
        }
        // Emit custom event asynchronously to avoid interfering with router's update cycle
        // This ensures the router finishes rendering before other components react to the change
        requestAnimationFrame(() => {
            window.dispatchEvent(new CustomEvent('routechange'))
        })
    }

    // Check if current path matches home route
    const isHomePage = currentPath === routes.HOME

    return (
        <main className={isHomePage ? 'home-page' : ''}>
            <Router onChange={handleRoute} key={locale}>
                <AsyncRoute
                    path={routes.HOME}
                    getComponent={HOME}
                    loading={() => <Loading />}
                />

                <AsyncRoute
                    path={routes.ABOUT}
                    getComponent={ABOUT}
                    loading={() => <Loading />}
                />

                <AsyncRoute
                    path={routes.CONSTELLATION}
                    getComponent={CONSTELLATION}
                    loading={() => <Loading />}
                />

                <AsyncRoute
                    path={routes.ARTISTS}
                    getComponent={ARTISTS}
                    loading={() => <Loading />}
                />

                <AsyncRoute
                    path={routes.CHAPTERS}
                    getComponent={CHAPTERS}
                    loading={() => <Loading />}
                />
            </Router>
        </main>
    )
}

export default Routes
